import Vue from 'vue';
import VueI18n from 'vue-i18n'
import App from './App.vue';
import requestHelper from "./api/requestHelper";

const fontStyleElement = document.createElement('link');
fontStyleElement.type = 'text/css';
fontStyleElement.rel = 'stylesheet';
fontStyleElement.href = requestHelper.createUrl('/webfont/stylesheet');
console.log({fontStyleElement, head: document.querySelector('head')});
document.querySelector('head').appendChild(fontStyleElement);
fontStyleElement.addEventListener('error', () => {
  console.error('ERROR: failed to dynamic load fonts stylesheet');
});

window.EventHandler = new Vue({
  data: {
    mouseMod: 1
  },
  watch: {
    mouseMod: function (newMouseMod) {
      window['w2p_mouse_mod'] = newMouseMod;
      this.$emit('newMouseModSelected', newMouseMod);
    }
  },
  created: function () {
    window['w2p_mouse_mod'] = this.mouseMod;
  }
});

// auswahl der topics die von debug in der browser konsole geloggt werden
localStorage.debug = 'canvas:*,app:*';

Vue.config.productionTip = false;

Vue.use(VueI18n);

new Vue({
  render: h => h(App),
}).$mount('#app');

Vue.config.devtools = true;